import React from "react";
export var BlockImage = function (_a) {
    var id = _a.id, url = _a.url, style = _a.style, alt = _a.alt, horizontalAlignment = _a.horizontalAlignment;
    return (React.createElement("div", { style: { textAlign: horizontalAlignment } },
        React.createElement("img", { id: id, alt: alt, src: url, style: style, className: "blockimage-0-62" })));
};
